module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO DE ACTIVIDADES POLITÉCNICAS.d3132031.pdf";